/**
 * proposalCatalog.js — shared formatting helpers & configuration option lists.
 * Product prices and rates now come from the database, so this file only
 * keeps UI-level constants (option arrays, formatters).
 */

// ─── Configuration Options ─────────────────────────────────
export const LICENSE_TYPES = [
  { value: 'BASIC', label: 'BÁSICA' },
  { value: 'PRO',   label: 'PRO' },
  { value: 'NONE',  label: 'Sin Licencia' },
];

export const MAINTENANCE_TYPES = [
  { value: 'ESTANDAR', label: 'ESTÁNDAR' },
  { value: 'PREMIUM',  label: 'PREMIUM' },
  { value: 'NONE',     label: 'Sin Mtto.' },
];

export const ZONES = [
  { value: 'ZONA_I',   label: 'ZONA I - Península Ibérica y Baleares (España y Portugal)' },
  { value: 'ZONA_II',  label: 'ZONA II - Islas Canarias, Francia, Italia, Alemania' },
  { value: 'ZONA_III', label: 'ZONA III - Reino Unido, Suiza, Países Bajos, Bélgica y Austria' },
  { value: 'ZONA_IV',  label: 'ZONA IV - Escandinavia, Polonia, Rep. Checa, Eslovaquia, Hungría, Otros' },
];

export const LOCKER_RANGES = [
  { value: '0-500', label: '1 - 500' },
  { value: '501-1000', label: '501 - 1000' },
  { value: '1001-2000', label: '1001 - 2000' },
];

export const INSTALLATION_TYPES = [
  { value: 'interior', label: 'Interior (CDF)' },
  { value: 'exterior', label: 'Exterior (INOX + HPL)' },
];

export const LOCK_TYPES = [
  { value: 'STANDARD', label: 'Standard' },
  { value: 'BLUETOOTH', label: 'Bluetooth' },
];

export const LOCK_ACCESS_TYPES = [
  { value: 'PIN',  label: 'PIN' },
  { value: 'RFID', label: 'RFID' },
];

export const LOCK_CLOSE_TYPES = [
  { value: 'HOOK',  label: 'Hook' },
  { value: 'SLIDE', label: 'Slide' },
];

export const SALE_MODES = [
  { value: 'purchase', label: 'Compra' },
  { value: 'rental', label: 'Alquiler' },
  { value: 'revenue_share', label: 'Revenue Share' },
];

export const OPERATING_MODES = [
  { value: '24H',      label: 'Día' },
  { value: 'Tiempo',   label: 'Tiempo' },
  { value: 'Apertura', label: 'Apertura' },
  { value: 'Paqueteria', label: 'Paquetería' },
  { value: 'PUBLIC',   label: 'Público' },
];

// ─── Formatting Helpers ────────────────────────────────────
export const fmt = (n) => {
  if (n === 0) return '-';
  return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
};

export const fmtAlways = (n) => {
  return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
};

export const fmtPct = (n) => {
  return n.toFixed(2) + '%';
};
